import React, { useState } from 'react';
import { Send, CheckCircle, Phone } from 'lucide-react';
import { trackLead } from '../lib/track';
import './Contact.css';

export default function Contact({ selectedPlan }) {
    const [plan, setPlan] = useState(selectedPlan || 'Vet inte än – börja med gratis prototyp');
    const [status, setStatus] = useState('idle'); // idle, submitting, success, error

    React.useEffect(() => {
        if (selectedPlan) {
            setPlan(selectedPlan);
        }
    }, [selectedPlan]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        // Spam protection (Honeypot)
        if (data._honey) return;

        if (!data.email || !data.name) return;

        setStatus('submitting');

        try {
            const response = await fetch("https://forms.briljans.se", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    name: data.name,
                    email: data.email,
                    phone: data.phone,
                    plan: plan,
                    message: data.message
                })
            });

            if (response.ok) {
                setStatus('success');
                e.target.reset();
                // Track conversion
                if (window.gtag_report_conversion) {
                    window.gtag_report_conversion();
                }
                trackLead();
            } else {
                throw new Error('Något gick fel.');
            }
        } catch {
            setStatus('error');
        }
    };

    return (
        <section className="contact" id="contact">
            <div className="container contact-wrapper">
                <div className="section-header">
                    <span className="section-eyebrow">Kontakt</span>
                    <h2 className="section-title">Starta med en gratis prototyp</h2>
                    <p>Fyll i formuläret så återkommer vi inom 24 timmar. Berätta gärna om din idé så kan vi skissa på ett designförslag helt kostnadsfritt!</p>
                    <p className="contact-direct">
                        Hellre prata direkt? Ring <a href="tel:0766140446"><Phone size={15} aria-hidden="true" /> 076-614 04 46</a> eller maila <a href="mailto:lucas@briljansdesign.se">lucas@briljansdesign.se</a>
                    </p>
                </div>

                {status === 'success' ? (
                    <div className="success-message">
                        <div className="success-icon">
                            <CheckCircle size={48} />
                        </div>
                        <h3 className="success-title">Tack för din förfrågan!</h3>
                        <p className="success-text">Vi hör av oss inom 24 timmar — ofta med en första skiss på din hemsida. Helt kostnadsfritt.</p>
                        <p className="success-call">Bråttom? Ring direkt: <a href="tel:0766140446">076-614 04 46</a></p>
                        <button type="button" className="success-reset" onClick={() => setStatus('idle')}>Skicka ett nytt meddelande</button>
                    </div>
                ) : (
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <input type="hidden" name="_template" value="table" />
                        {/* Honeypot for spam protection */}
                        <input type="text" name="_honey" style={{ display: 'none' }} />

                        <div className="form-group">
                            <label htmlFor="contact-name" className="form-label">Namn</label>
                            <input type="text" id="contact-name" name="name" className="form-input" placeholder="Ditt namn" autoComplete="name" required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="contact-email" className="form-label">E-post</label>
                            <input type="email" id="contact-email" name="email" className="form-input" placeholder="din@email.com" autoComplete="email" required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="contact-phone" className="form-label">Telefon (valfritt — vi ringer gärna upp)</label>
                            <input type="tel" id="contact-phone" name="phone" className="form-input" placeholder="070-123 45 67" autoComplete="tel" />
                        </div>

                        <div className="form-group">
                            <label htmlFor="plan-select" className="form-label">Intresse</label>
                            <select id="plan-select" className="form-input" name="plan" value={plan} onChange={(e) => setPlan(e.target.value)}>
                                <option>Start</option>
                                <option>Standard</option>
                                <option>Pro</option>
                                <option>Vet inte än – börja med gratis prototyp</option>
                                <option>Övrigt</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="contact-message" className="form-label">Meddelande</label>
                            <textarea id="contact-message" className="form-textarea" name="message" placeholder="Berätta om ditt projekt..." required></textarea>
                        </div>

                        <button type="submit" className="btn-submit" disabled={status === 'submitting'}>
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                {status === 'submitting' ? 'Skickar...' : 'Skicka förfrågan'}
                                {status !== 'submitting' && <Send size={18} />}
                            </span>
                        </button>
                        {status === 'error' && (
                            <p className="form-error">
                                Något gick fel. Försök igen, maila <a href="mailto:lucas@briljansdesign.se">lucas@briljansdesign.se</a> eller ring <a href="tel:0766140446">076-614 04 46</a>.
                            </p>
                        )}
                    </form>
                )}
            </div>
        </section>
    );
}
